import {Box, Button} from "@material-ui/core";
import Call from "../../service/API";
import DeFaultImage from "../../assets/img/no-image-icon.png";

const AddLogo = ({logoUrl, changeLogo}) => {

    const uploadMedia = (file) => {
        if (file) {
            let Data = new FormData()
            Data.append("file", file)
            Call("POST", "Updload/admin", Data)
                .then((response) => {
                    if (response.data.code === 200) {
                        changeLogo("http://217.144.106.32:6565" + response.data.data.fileurl)
                    }
                })
                .catch((error) => {
                    if (error.response) {
                        const data = error.response.data;
                    }
                });
        }

    };

    return (<>
        <Box mt={2}>
            <img src={logoUrl?logoUrl:DeFaultImage}  height="100px"/>
        </Box>
        <input
            accept="image/*"
            type="file"
            id="select-image"
            style={{display: 'none'}}
            onChange={e => uploadMedia(e.target.files[0])}
        />
        <label htmlFor="select-image">
            <Button variant="contained" color="primary" component="span">
                بارگزاری لوگو
            </Button>
        </label>
    </>)
}
export default AddLogo;